export default __webpack_public_path__ + "static/media/tilda_black.94fa6318.svg";